import baseAjaxConfig from 'actions/BaseAjaxConfig';
import ApiCaller from './ApiCaller';
export var MARKETPLACE_SERVICEABILITY_ACTIONS;
(function (MARKETPLACE_SERVICEABILITY_ACTIONS) {
    MARKETPLACE_SERVICEABILITY_ACTIONS["GET_MARKETPLACE_SERVICEABILITY_REQUEST"] = "GET_MARKETPLACE_SERVICEABILITY_REQUEST";
    MARKETPLACE_SERVICEABILITY_ACTIONS["GET_MARKETPLACE_SERVICEABILITY_SUCCESS"] = "GET_MARKETPLACE_SERVICEABILITY_SUCCESS";
    MARKETPLACE_SERVICEABILITY_ACTIONS["GET_MARKETPLACE_SERVICEABILITY_ERROR"] = "GET_MARKETPLACE_SERVICEABILITY_ERROR";
})(MARKETPLACE_SERVICEABILITY_ACTIONS || (MARKETPLACE_SERVICEABILITY_ACTIONS = {}));
export function getMarketplaceServiceability() {
    return (dispatch) => {
        dispatch({
            type: MARKETPLACE_SERVICEABILITY_ACTIONS.GET_MARKETPLACE_SERVICEABILITY_REQUEST
        });
        const apiConfig = Object.assign({}, baseAjaxConfig, {
            pathname: '/api/1/mp-serviceability',
            action: MARKETPLACE_SERVICEABILITY_ACTIONS.GET_MARKETPLACE_SERVICEABILITY_REQUEST
        });
        return ApiCaller.get(apiConfig).then(json => dispatch({
            type: MARKETPLACE_SERVICEABILITY_ACTIONS.GET_MARKETPLACE_SERVICEABILITY_SUCCESS,
            data: json
        }), error => {
            dispatch({
                type: MARKETPLACE_SERVICEABILITY_ACTIONS.GET_MARKETPLACE_SERVICEABILITY_ERROR,
                error
            });
        });
    };
}
